import script from "./RestorePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./RestorePassword.vue?vue&type=script&setup=true&lang=js"

import "./RestorePassword.vue?vue&type=style&index=0&id=b52fa55a&lang=css"

const __exports__ = script;

export default __exports__